import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/* This is copied over from @types/react since it's not exported there */
export type Booleanish = boolean | "true" | "false";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function booleanishToBoolean(value: Booleanish) {
  return value === true || value === "true";
}
export type ErrorableReturn<T> =
  | {
      data: T;
      error?: undefined;
    }
  | {
      data?: undefined;
      error: Error;
    };
